import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import Toast from "components/Toast"
import { MocUserRole } from "core/services/models/Enums"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import { useLocation } from "react-router-dom"
import Select from "react-select"
import Button from "../../../../components/Button"
import InputField from "../../../../components/InputField"
import {
  addNewBed,
  getBedManagementDetailsById,
  getCenterDetails,
  updateBedManagement
} from "../../../../core/services/api"
import "./AddNewBed.scss"

function AddNewBed() {
  const history = useHistory()
  const [role, setRole] = useState<string>()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState([])
  const [formErrors, setFormErrors] = useState<any>()
  const location = useLocation()
  const id = location?.state?.idValue
  const [displayToast, toggleDisplayToast] = useState<any>()
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);

  console.log(location, "location")
  const [bedManagementInfo, setbedManagementInfo] = useState<any>({
    roomName: "",
    roomShortName: "",
    centerId: ""
  })

  const [centerDetail, setCenterDetail] = useState<any>([])
  const [centerId, setCenterId] = useState<any>()
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })
  useEffect(() => {
    setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })
  }, [])

  const bedDetails = {
    name: "",
    shortName: "",
    // availableTo: "13:00",
    // availableFrom: "13:00",
    // slotDuration: "",
    id: "",
    // centerId: ""
  }
  let [bedDetailsInfo, setBedDetailsInfo] = useState([bedDetails])

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setFormErrors(validate(bedManagementInfo))
    setIsSubmit(true)
  }
  useEffect(() => {
    if (id) {
      getBedManagementDetailsById(`${id}`)
        .then((res) => {
          setbedManagementInfo({
            roomName: res.name,
            roomShortName: res.shortName,
            centerId: res.centerId

          })
          const test = res.bedDetails.map(
            (ele: {
              id: any
              // slotDuration: any
              name: any
              shortName: any
              // centerId: any
            }) => {
              return {
                name: ele.name,
                shortName: ele.shortName,
                // availableTo: "13:00",
                // availableFrom: "13:00",
                // slotDuration: ele.slotDuration,
                id: ele.id,
                // centerId: ele.centerId
              }
            }
          )?.sort((a: any, b: any) => a?.name?.toLowerCase()?.localeCompare(b?.name?.toLowerCase()))
          setBedDetailsInfo(test)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [id])

  const validate = (values: any) => {

    const errors: any = {}

    if (!values.roomName) {
      errors["roomName"] = "roomName is required"
    }

    return errors
  }
  useEffect(() => {
    if (id === undefined) {
      if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
        let referralDoctorDetail: any
        if (role === MocUserRole?.SYSTEM_ADMIN) {
          referralDoctorDetail = {
            name: bedManagementInfo.roomName,
            shortName: bedManagementInfo.roomShortName,
            centerId: bedManagementInfo?.centerId,
            bedDetails: bedDetailsInfo,
          }
        } else {
          referralDoctorDetail = {
            name: bedManagementInfo.roomName,
            shortName: bedManagementInfo.roomShortName,
            centerId: userDetail?.currentCenter?.centerId,
            bedDetails: bedDetailsInfo,
          }
        }

        addNewBed(referralDoctorDetail)
          .then((data) => {
            setResData(data)
            toggleDisplayToast({ text: "Bed has been added successfully", type: "success" })
          })
          .catch((err) => {
            console.log(err)
          })
      }
      return
    } else {
      if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
        let updateBedManagementReq: any
        if (role === MocUserRole?.SYSTEM_ADMIN) {
          updateBedManagementReq = {
            name: bedManagementInfo.roomName,
            shortName: bedManagementInfo.roomShortName,
            centerId: bedManagementInfo?.centerId,
            bedDetails: bedDetailsInfo,
            id: id,
          }
        } else {
          updateBedManagementReq = {
            name: bedManagementInfo.roomName,
            shortName: bedManagementInfo.roomShortName,
            centerId: userDetail?.currentCenter?.centerId,
            bedDetails: bedDetailsInfo,
            id: id,
          }
        }

        console.log(id, "id");
        updateBedManagement(id, updateBedManagementReq)
          .then((data) => {
            toggleDisplayToast({ text: "Bed has been updated successfully", type: "success" })
          })
          .catch((err) => {
            console.log("err", err)
            toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
          })
      }
    }
  }, [formErrors])
  return (
    <div className="add-new-bed-container ">
      <div style={{ display: 'flex', alignItems: 'center', paddingTop: '31px' }}>
        <div
          className="approval-back-image"
          onClick={() => {
            history.push({
              pathname: "/bedManagement",
              state: { centerId: location?.state?.centerId, centerName: location?.state?.centerName, previousPath: 'addBed' },
            })
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="add-new-bed-heading">Add / Edit New Bed</div>
      </div>
      <div className="add-new-bed-details">
        <form onSubmit={handleSubmit}>
          <div className="row locationDetails">
            {role === 'SYSTEM_ADMIN' ? <>
              <div className="col-2" style={{ padding: 0 }}>
                <label className="textlabel">Location:</label>
              </div>
              <div className="col-3" style={{ padding: 0 }}>
                <Select
                  styles={customSelectStyles()}
                  onChange={(option: any) => {
                    setbedManagementInfo({
                      ...bedManagementInfo,
                      centerId: option?.value
                    })
                  }}
                  value={dropdownCenters.filter(
                    ({ value }: any) => value === bedManagementInfo?.centerId
                  )}
                  options={dropdownCenters}
                  isDisabled={readOnly}
                />
              </div>
            </> : <></>}
          </div>
          <div className="row second-container">
            <div className="col-2">
              <label className="textlabel">Room Name:</label>
            </div>

            <div className="col-3">
              <InputField
                placeholder="Room name"
                value={bedManagementInfo?.roomName}
                handleChange={(e) =>
                  setbedManagementInfo({
                    ...bedManagementInfo,
                    roomName: e.target.value,
                  })
                }
                readOnly={readOnly}
                errorMsg={formErrors?.roomName}
              />
            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <label className="textlabel">Room Short Name:</label>
            </div>

            <div className="col-3">
              <InputField
                placeholder="Room short name"
                readOnly={readOnly}
                value={bedManagementInfo?.roomShortName}
                handleChange={(e) =>
                  setbedManagementInfo({
                    ...bedManagementInfo,
                    roomShortName: e.target.value,
                  })
                }
                errorMsg={formErrors?.roomShortName}
              />
            </div>


          </div>
          {bedDetailsInfo?.map((e, index) => {
            return (
              <div className="bed-details-container">
                <div className="row nameDetails">
                  <div className="col-2">
                    <label className="textlabel">Bed Name:</label>
                  </div>
                  <div className="col-3">
                    <InputField
                      readOnly={readOnly}
                      placeholder="Bed name"
                      value={bedDetailsInfo[index].name}
                      handleChange={(e) => {
                        const values = [...bedDetailsInfo]
                        values[index].name = e.target.value
                        setBedDetailsInfo([...values])
                      }}
                    />
                  </div>
                  <div className="col-1"></div>
                  <div className="col-2">
                    <label className="textlabel">Bed Short Name:</label>
                  </div>
                  <div className="col-3">
                    <InputField
                      readOnly={readOnly}
                      placeholder="Bed Short Name"
                      value={bedDetailsInfo[index].shortName}
                      handleChange={(e) => {
                        const values = [...bedDetailsInfo]
                        values[index].shortName = e.target.value
                        setBedDetailsInfo([...values])
                      }}
                    />
                  </div>

                  <div className="col-1">
                    <div
                      className="delete-icon"
                      onClick={() => {
                        if (bedDetailsInfo.length > 1) {
                          const values = [...bedDetailsInfo]
                          values.splice(index, 1)
                          setBedDetailsInfo(values)
                        }
                      }}
                    >
                      <img
                        src="../../../../assets/images/delete-icon.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          })}

          <div className="add-new-bed-container">
            {readOnly ? <></> : <>
              <div
                className="add-new-button"
                onClick={() => setBedDetailsInfo([...bedDetailsInfo, bedDetails])}

              >
                Add New Bed
              </div>
            </>}
          </div>

          <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                type={"button"}
                outline={true}
                disabled={readOnly}
                onClick={() => history.push({
                  pathname: "/bedManagement",
                  state: { centerId: location?.state?.centerId, centerName: location?.state?.centerName, previousPath: 'addBed' },
                })}
                id="cancel"
              />
            </div>
            <div>
              <Button disabled={readOnly} text="Save" type="submit" id="save" />
            </div>
          </div>
        </form>
      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            history.push({
              pathname: "/bedManagement",
              state: { centerId: location?.state?.centerId, centerName: location?.state?.centerName, previousPath: 'addBed' },
            })
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  )
}
export default AddNewBed
